module.exports = __webpack_public_path__ + "static/media/8.63518081.png";